import React from "react";
//icons
import ForwardToInboxOutlinedIcon from "@mui/icons-material/ForwardToInboxOutlined";
import ShareLocationRoundedIcon from "@mui/icons-material/ShareLocationRounded";
//translation
import useTranslation from "../hooks/useTranslation";
//next
import Link from "next/link";

const AboutUsLayout = () => {
  const { t } = useTranslation();
  return (
    <div className="h-full pt-[76px] lg:pt-[109px]">
      <div className="relative">
        <img src="/images/help_bg.jpg" className="w-full h-[250px] " />
        <div className="absolute bg-[#000000] bg-opacity-40 top-0  h-[250px] w-full flex flex-col justify-center gap-6 md:gap-10 items-center py-6 lg:py-10">
          <p className="text-white text-2xl md:text-4xl lg:text-6xl font-MyriadPro font-semibold ">
            {t("A propos de nous !")}
          </p>
        </div>
      </div>
      <div className="max-w-[1366px] h-full mx-auto pt-[5rem] pb-[109px] px-[30px]">
        <h1 className="relative mb-3 pt-[1rem] font-bold before:content-[''] before:absolute before:bg-primary before:w-[2rem] before:h-[0.3rem] before:top-[0]">
          {t("QUI NOUS SOMMES")}
        </h1>
        <p className="text-base leading-7 text-[gray] mb-5">
          {t(
            "La plateforme FIDDARI met simplement à disposition des freelancer qualifiés dans leurs domaines pour fournir les services demandés par les abonnés de la plateforme en tant que clients"
          )}
        </p>
        <h1 className="relative mb-3 pt-[1rem] font-bold before:content-[''] before:absolute before:bg-primary before:w-[2rem] before:h-[0.3rem] before:top-[0]">
          {t("CE QUI NOUS A INTERESSE")}
        </h1>
        <p className="text-base leading-7 text-[gray] mb-5">
          {t(
            "Nous nous concentrons sur la réalisation d'une plate-forme hautement personnalisable et évolutive conçue pour répondre aux besoins des client pour trouver leur freelancers idéal."
          )}
        </p>
        <div className="container flex flex-col gap-1 text-based">
          <h1 className="relative mb-3 pt-[1rem] font-bold before:content-[''] before:absolute before:bg-primary before:w-[2rem] before:h-[0.3rem] before:top-[0]">
            {t("CONTACTEZ NOUS")}
          </h1>
          <span className="text-based mb-3">
            <ForwardToInboxOutlinedIcon className="inline-block ltr:mr-3 rtl:ml-3 text-[20px]" />
            {t("Email")} :
            <Link
              href="mailto:contact@fiddari.com"
              className="m-2 underline text-pink"
            >
              contact@fiddari.com
            </Link>
          </span>
          <div className="flex gap-1 text-based">
            <ShareLocationRoundedIcon className="inline-block ltr:mr-3 rtl:ml-3 text-[20px]" />
            <p>Bab ezzouar rue Arbi Ben Mhidi, Alger - Algerie</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutUsLayout;
